/* ==========================================================
   CURITIV — Shopify Forms Hebrew RTL
   ========================================================== */

(function () {
  'use strict';

  const STYLE_ID = 'curitiv-shopify-forms-rtl';

  const rtlCSS = `
    /* Form */
    form[data-testid="form"],
    form {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Labels */
    label {
      direction: rtl !important;
      text-align: right !important;
      width: 100% !important;
    }

    /* Text inputs */
    input:not([type="tel"]):not([type="checkbox"]):not([type="radio"]),
    textarea {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Placeholders */
    input:not([type="tel"])::placeholder,
    textarea::placeholder {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Native Select */
    select {
      direction: rtl !important;
      text-align: right !important;
      text-align-last: right !important;

      padding-right: 16px !important;
      padding-left: 46px !important;
    }

    select option {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Shopify custom dropdown */
    [role="combobox"],
    button[aria-haspopup="listbox"] {
      direction: rtl !important;
      text-align: right !important;

      padding-right: 16px !important;
      padding-left: 46px !important;

      position: relative !important;
    }

    /* Dropdown text */
    [role="combobox"] span,
    button[aria-haspopup="listbox"] span {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Dropdown arrow → left */
    [role="combobox"] svg,
    button[aria-haspopup="listbox"] svg {
      position: absolute !important;
      left: 16px !important;
      right: auto !important;

      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    /* Open dropdown options */
    [role="listbox"],
    [role="option"] {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Phone stays LTR */
    input[type="tel"] {
      direction: ltr !important;
      text-align: left !important;
    }

    /* But phone label stays RTL */
    label[for*="phone"] {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Textarea */
    textarea {
      min-height: 120px;
    }

    /* Checkbox / Radio labels */
    input[type="checkbox"] + label,
    input[type="radio"] + label {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Messages */
    [role="alert"],
    [role="status"] {
      direction: rtl !important;
      text-align: right !important;
    }

    /* Submit button */
    button[type="submit"] {
      direction: rtl !important;
      text-align: center !important;
    }
  `;


  /* ----------------------------------------------------------
     Check if current storefront language is Hebrew
     ---------------------------------------------------------- */

  function isHebrew() {
    const lang = (
      document.documentElement.getAttribute('lang') || ''
    ).toLowerCase();

    return (
      lang.startsWith('he') ||
      document.documentElement.dir === 'rtl'
    );
  }


  /* ----------------------------------------------------------
     Inject CSS into a Shadow Root
     ---------------------------------------------------------- */

  function injectRTL(root) {
    if (!root) return;

    if (root.getElementById(STYLE_ID)) {
      return;
    }

    const style = document.createElement('style');

    style.id = STYLE_ID;
    style.textContent = rtlCSS;

    root.appendChild(style);
  }


  /* ----------------------------------------------------------
     Search page for Shopify Forms Shadow DOM
     ---------------------------------------------------------- */

  function findShopifyForms() {
    if (!isHebrew()) return;

    document.querySelectorAll('*').forEach((element) => {

      if (!element.shadowRoot) return;

      const root = element.shadowRoot;

      /*
       * Only inject if this Shadow DOM
       * actually contains a Shopify form.
       */
      const form =
        root.querySelector('form[data-testid="form"]') ||
        root.querySelector('form');

      if (!form) return;

      injectRTL(root);

      form.setAttribute('dir', 'rtl');
    });
  }


  /* ----------------------------------------------------------
     Initial load
     ---------------------------------------------------------- */

  function initCuritivFormsRTL() {

    if (!isHebrew()) return;

    findShopifyForms();


    /* Shopify Forms can load asynchronously */

    const pageObserver = new MutationObserver(() => {
      findShopifyForms();
    });

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });


    /*
     * Additional short retry period.
     * Useful when Shopify Forms loads after the page/app embed.
     */

    let attempts = 0;

    const retry = setInterval(() => {

      findShopifyForms();

      attempts++;

      if (attempts >= 20) {
        clearInterval(retry);
      }

    }, 500);


    /* Shopify Theme Editor */

    document.addEventListener(
      'shopify:section:load',
      findShopifyForms
    );

    document.addEventListener(
      'shopify:section:reorder',
      findShopifyForms
    );
  }


  /* ----------------------------------------------------------
     Start
     ---------------------------------------------------------- */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initCuritivFormsRTL
    );

  } else {

    initCuritivFormsRTL();

  }

})();